export default class MemoryStorage {
  constructor() {
    this.storage = void 0;
    this.storage = new Map();
  }
  store(log) {
    this.storage.set(log.uid, log);
    if (this.storage.size > MemoryStorage.storageMaxSize) {
      this.storage.delete(this.storage.keys().next().value); // Getting first element key
    }
  }
  delete(logKey) {
    this.storage.delete(logKey);
  }
  getLogs(limit) {
    return Array.from(this.storage.values()).slice(0, limit);
  }
  getLogsOfType(limit, logTypes) {
    return Array.from(this.storage.values()).filter(log => logTypes === null || logTypes.includes(log.type)).slice(0, limit);
  }
  getLogsNotOfType(limit, logTypes) {
    return Array.from(this.storage.values()).filter(log => logTypes === null || !logTypes.includes(log.type)).slice(0, limit);
  }
}
MemoryStorage.storageMaxSize = 750000;
//# sourceMappingURL=MemoryStorage.js.map